import React, { useRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import { open, close } from '../../../helpers';

const Suggestions = ({ title, suggestions, endpoint, searchQueryParam }) => {
  const suggestionsRef = useRef();

  const toggle = useCallback(() => {
    if (suggestions.length) {
      suggestionsRef.current.style.visibility = 'visible';
      open({ element: suggestionsRef.current });
    } else {
      close({
        element: suggestionsRef.current,
        onComplete: () => {
          suggestionsRef.current.style.visibility = 'hidden';
        }
      });
    }
  }, [suggestions.length]);

  const stripHtml = useCallback(html => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }, []);

  useEffect(() => {
    toggle();
  }, [toggle]);

  return (
    <div className="header-search__suggestions" ref={suggestionsRef}>
      {!!suggestions.length && (
        <div className="header-search__suggestions-inner">
          <h2 className="header-search__suggestions-title">{title}</h2>
          <ul className="header-search__suggestions-list">
            {suggestions.map(suggestion => (
              <li key={suggestion}>
                <a
                  href={`${endpoint}?${searchQueryParam}=${stripHtml(
                    suggestion
                  )}`}
                  dangerouslySetInnerHTML={{ __html: suggestion }}
                />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

Suggestions.propTypes = {
  title: PropTypes.string.isRequired,
  suggestions: PropTypes.array.isRequired,
  endpoint: PropTypes.string.isRequired,
  searchQueryParam: PropTypes.string.isRequired
};

export default Suggestions;
